import { Container, Row, Col } from "react-bootstrap";
import clsx from "classnames";
import classes from "./styles.module.scss";
import { Title, Description, CTA } from "@/ui";

export const FeaturedListImage = ({
  className,
  bgColor,
  title,
  titleColor,
  textColor,
  description,
  items = [],
  showCta,
  cta,
  image,
  reverse,
  statColor,
}) => {
  return (
    <div className={clsx(className, `bg-${bgColor}`)}>
      <Container>
        <Title title={title} className={clsx("mb-3", `text-${titleColor}`)} />
        <Description description={description} className={clsx(`text-${textColor}`)} />
        <Row
          className={clsx("flex-column-reverse gx-5", {
            "flex-md-row-reverse": reverse,
            "flex-md-row": !reverse,
          })}
          style={{ alignItems: "center" }}
        >
          <Col md={5} className={classes.imageCol}>
            <div className={classes.imageContainer}>
              {image?.url && <img src={image.url} alt="Featured" className={classes.image} />}
            </div>
          </Col>
          <Col md={7}>
            <ol className={classes.list}>
              {items.map(({ title, text, titleStatColour, textStatColour }, idx) => (
                <li key={idx} className={classes.listItem}>
                  <div className="d-flex align-items-start gap-3">
                    <div className="d-flex align-items-start gap-2">
                      <Title
                        title={String(idx + 1).padStart(2, "0")}
                        tag="h3"
                        className={clsx("h3", classes.index, statColor)}
                      />
                      <div>
                        <Title title={title} tag="h3" className={clsx("h3", titleStatColour)} />
                        <Description description={text} className={clsx("description", textStatColour)} />
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ol>
            {showCta && cta && (
              <CTA
                className="mt-4"
                label={cta.label}
                href={cta.href}
                variant={cta.variant}
                data-sourceflow-prop="cta"
              />
            )}
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default FeaturedListImage;
